import React from 'react'
import { useFence } from '../contexts/FenceContext'
import { HouseStyle } from '../contexts/FenceContext'

const HouseStyleSelector: React.FC = () => {
  const { state, dispatch } = useFence()

  const availableStyles: HouseStyle[] = [
    {
      id: 'modern',
      name: 'Nowoczesny',
      model: '/Model_obj/new_house.obj'
    },
    {
      id: 'classic',
      name: 'Klasyczny',
      model: '/dom_normal.dae'
    }
  ]

  const handleStyleSelect = (style: HouseStyle | null) => {
    dispatch({ type: 'SELECT_HOUSE_STYLE', payload: style })
  }

    return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm">
      <h3 className="font-sans text-sm font-semibold text-gray-900 mb-4">
        Styl domu
      </h3>
      
      <div className="space-y-3">
        {/* Brak domu */}
        <div
          className={`p-3 border-2 rounded-lg cursor-pointer transition-all touch-manipulation mobile-button ${
            !state.selectedHouseStyle
              ? 'border-red-600 bg-red-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
          onClick={() => handleStyleSelect(null)}
        >
          <div className="flex items-center space-x-3">
            <div className="flex-1">
              <h4 className="font-sans font-semibold text-gray-900 text-sm">Brak domu</h4>
              <p className="font-sans text-xs text-gray-600">Projektowanie bez kontekstu</p>
            </div>
            
            {!state.selectedHouseStyle && (
              <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
            )}
          </div>
        </div>

        {/* Dostępne style */}
        {availableStyles.map((style) => (
          <div
            key={style.id}
            className={`p-3 border-2 rounded-lg cursor-pointer transition-all touch-manipulation mobile-button ${
              state.selectedHouseStyle?.id === style.id
                ? 'border-red-600 bg-red-50'
                : 'border-gray-200 hover:border-gray-300'
            }`}
            onClick={() => handleStyleSelect(style)}
          >
            <div className="flex items-center space-x-3">
              <div className="flex-1">
                <h4 className="font-sans font-semibold text-gray-900 text-sm">{style.name}</h4>
                <p className="font-sans text-xs text-gray-600">
                  {style.id === 'modern' ? 'Minimalistyczny' : 'Tradycyjny'}
                </p>
              </div>
              
              {state.selectedHouseStyle?.id === style.id && (
                <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HouseStyleSelector
